/**
 * `/tenants/$tenantId/assistant` — one tenant's assistant access, budget and
 * daily caps (CC-440).
 *
 * A standalone sibling route like `.brand.tsx`, NOT a tab: tenant "tabs" in
 * this app are local component state inside TenantDetailScreen, so a sibling
 * route renders its own page. Reached from the `/assistant` board rows.
 */
import { createFileRoute } from "@tanstack/react-router";
import { TenantAssistantScreen } from "../features/assistant/TenantAssistantScreen";

export const Route = createFileRoute("/_auth/tenants/$tenantId/assistant")({
  staticData: {
    breadcrumb: { labelKey: "nav.assistant" },
  },
  component: TenantAssistantScreen,
});
